// extracted by mini-css-extract-plugin
export var csatScore = "_io-5";
export var header = "_io-1";
export var panelWrapper = "_io-2";
export var postPreview = "_io-3";
export var rightContent = "_io-0";
export var wrappingText = "_io-4";